export default "__VITE_ASSET__BXV5dpEp__"